
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Pago from "../pages/pago/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pago-entradas",
    element: <Pago />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
